import { Button, ExtendedButtonProps, Flex } from "@xcorejs/ui";
import { PropsWithChildren, ReactNode } from "react";
import styled from "styled-components";

export type IconButtonProps = Omit<ExtendedButtonProps, "leftIcon" | "_leftIcon" | "rightIcon" | "_rightIcon"> & {
  icon: ReactNode;
  iconFill?: string;
  href?: string;
  target?: string;
  centerInnerGroup?: boolean;
};

const resolveIconFill = (fill: string) => styled("span")`
  & > svg path {
    fill: ${fill};
  }

  display: flex;
`;

export const IconButton = ({ icon, children, iconFill, centerInnerGroup, ...props }: PropsWithChildren<IconButtonProps>) => {
  const Icon = iconFill ? resolveIconFill(iconFill) : null;

  return (
    <Button {...props}>
      <Flex
        alignItems="center"
        width="100%"
        height="100%"
        style={{ gap: "1.5rem" }}
        {...(centerInnerGroup && { justifyContent: "center" })}
      >
        {iconFill ? Icon && <Icon>{icon}</Icon> : icon}
        {children}
      </Flex>
    </Button>
  );
};

export default IconButton;
